import {Divider} from '@/components/ui/divider/Divider'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {DayAvailability} from '@/features/users-availability/components/day-availability/DayAvailability'
import {DAYS_OF_WEEK} from '@/features/users-availability/types'
import {FC, Fragment} from 'react'

export const UserAvailabilityForm: FC = () => {
    return (
        <Flexbox direction="column" gap={4} fullWidth>
            {DAYS_OF_WEEK.map((day, index) => (
                <Fragment key={day}>
                    <DayAvailability day={day} />
                    {index !== DAYS_OF_WEEK.length - 1 && <Divider direction="horizontal" />}
                </Fragment>
            ))}
        </Flexbox>
    )
}
